import httpClient from "@/services/http-client";
import { CreateWordRequest, CreateWordResponse, GetWordListResponse, GetWordListRequest, GetWordItemResponse, GetWordStatsResponse } from "./word-model";
import { Paginated } from "../response-models";

export class WordService {
    getItem = async (id: string): Promise<GetWordItemResponse> => {
        const { data } = await httpClient.get<GetWordItemResponse>(`/api/words/${id}`);
        return data;
    }

    deleteItem = async (id: string): Promise<boolean> => {
        const { data } = await httpClient.delete<boolean>(`/api/words/${id}`);
        return data;
    }

    getPageItems = async (request?: GetWordListRequest): Promise<Paginated<GetWordListResponse>> => {
        let apiPath = "/api/words?";

        if (request) {
            if (request.text)
                apiPath += `text=${request.text}&`;

            if (request.types && request.types.length) {
                request.types.forEach(type => {
                    apiPath += `types=${type}&`;
                });
            }

            if (request.sort) {
                apiPath += `sort=${request.sort}&`;
            }

            if (request.hasPronunciation === true || request.hasPronunciation === false) {
                apiPath += `hasPronunciation=${request.hasPronunciation}&`;
            }

            if (request.topicIds && request.topicIds.length) {
                request.topicIds.forEach(topicId => {
                    apiPath += `topicIds=${topicId}&`;
                });
            }

            if (request.pageNumber) {
                apiPath += `pageNumber=${request.pageNumber}&`;
            }

            if (request.pageSize) {
                apiPath += `pageSize=${request.pageSize}`;
            }
        }

        const { data } = await httpClient.get<Paginated<GetWordListResponse>>(apiPath);
        return data;
    }

    create = async (request: CreateWordRequest): Promise<CreateWordResponse> => {
        const { data } = await httpClient.post<CreateWordResponse>("/api/words", request);
        return data;
    }

    update = async (id: string, request: CreateWordRequest): Promise<CreateWordResponse> => {
        const { data } = await httpClient.put<CreateWordResponse>(`/api/words/${id}`, request);
        return data;
    }

    getStats = async (): Promise<GetWordStatsResponse | null> => {
        const { data } = await httpClient.get<GetWordStatsResponse | null>(`/api/words/stats`);
        return data;
    }
}

const wordService = new WordService();

export default wordService;